export default __webpack_public_path__ + "static/cara-2f398469f1fc111efb62a2c5045b2300.png";